






























import { Component, Vue } from 'vue-property-decorator'
import SlideBar from '@/apps/open/views/fileCenter/components/SlideBar.vue'
import DocRate from './components/DocRate.vue'
import privateDocMenu from './PrivateDocMenu.json'

@Component({
  components: {
    SlideBar,
    DocRate
  }
})
export default class Wwo extends Vue {
  sliderBarOpeneds = ['/docs/wwo/join', '/docs/wwo/access']
  slideBarActive = ''
  breadList = []
  dropdownList = []
  dropdownSelectUrl = ''

  created () {
    this.initSlideBar(this.$route.path)
    this.initBreadcrumb(this.$route)
  }

  beforeRouteUpdate (to: any, from: any, next: any) {
    this.initSlideBar(to.path)
    this.initBreadcrumb(to)
    next()
  }

  mounted () {
    window.addEventListener('scroll', this.onBodyScroll, true)
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get fileCenterMenu () {
    const publicDocMenu = [
      {
        path: '/docs/wwo/access-know',
        name: '接入须知',
        icon: ''
      },
      {
        path: '/docs/wwo/access/file-access-url',
        name: '接入方式',
        icon: ''
      },
      {
        path: '/docs/wwo/access/api-list',
        name: '回调API标准',
        icon: ''
      },
      {
        path: '/docs/wwo/access/jssdk-import',
        name: 'JsSDK定制',
        icon: ''
      },
      {
        path: '/docs/wwo/access/sdk-demo',
        name: 'SDK&DEMO',
        icon: ''
      },
      {
        path: '/docs/wwo/access/signature',
        name: '签名说明',
        icon: ''
      },
      {
        path: '/docs/wwo/access/error-code',
        name: '常见错误码',
        icon: ''
      },
      {
        path: '/docs/wwo/access/questions',
        name: '常见问题',
        icon: ''
      },
      {
        path: '/docs/wwo/access/charge-standard',
        name: '计费说明',
        icon: ''
      }
    ]
    return this.isPrivate ? privateDocMenu.doc_online_edit : publicDocMenu
  }

  beforeDestroy () {
    window.removeEventListener('scroll', this.onBodyScroll, true)
  }

  onBodyScroll () {
    let scrollTop = document.body.scrollTop + document.documentElement.scrollTop
    let elHeaderHeight = document.getElementsByClassName('el-header')[0].clientHeight
    let elAside = document.getElementsByClassName('el-aside')[0] as HTMLElement
    let elMain = document.getElementsByClassName('el-main')[0] as HTMLElement
    let elBreadCrumb = document.getElementsByClassName('el-breadcrumb')[0] as HTMLElement

    if (scrollTop > elHeaderHeight) {
      elAside.style.position = 'fixed'
      elAside.style.top = '66px'
      elMain.style.marginLeft = '231px'
      elBreadCrumb.style.position = 'fixed'
      elBreadCrumb.style.top = '66px'
    } else {
      elAside.style.position = 'relative'
      elAside.style.top = '0px'
      elMain.style.marginLeft = '0px'
      elBreadCrumb.style.position = 'relative'
      elBreadCrumb.style.top = '0px'
    }
  }

  initSlideBar (toIndex: string) {
    this.slideBarActive = toIndex
  }

  initBreadcrumb (curRoute: any) {
    let matched = curRoute.matched.filter((item: any) => item.meta.title)
    this.breadList = matched
    this.dropdownList = curRoute.meta.aimtilelist
  }

  dropdownItemOnclick (index: number) {
    this.dropdownSelectUrl = '#s' + index
  }
}
